export enum TypeMontant {
    NDF = 3,
    IJ = 4,
    FACTURE = 5,
    DOSSIER_VOYAGE = 6,
    FRAIS_PREVISIONNEL = 7
}
